import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  question: '¿Cuándo recibo el libro?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico con el enlace de descarga para que empieces hoy mismo.'
}, {
  question: '¿Es una dieta estricta?',
  answer: 'No. Es un plan de alimentación antiinflamatoria diseñado para nutrir tu cuerpo, no para restringirlo. No pasarás hambre ni contarás calorías.'
}, {
  question: '¿Funciona si no sé cocinar?',
  answer: 'Sí, absolutamente. Las recetas son extremadamente sencillas, rápidas y usan ingredientes que encuentras en cualquier supermercado o mercado local.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tienes 7 días de garantía total. Si por alguna razón sientes que este plan no es para ti, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  question: '¿Es seguro el pago?',
  answer: 'Totalmente seguro. Utilizamos Hotmart, la plataforma de productos digitales más grande y segura de Latinoamérica, con encriptación de grado bancario.'
}, {
  question: '¿Puedo comer fuera de casa?',
  answer: 'Sí. Incluimos una guía específica (Bono #4) con estrategias para comer en restaurantes o eventos sociales sin sabotear tu progreso.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-111">
      {FAQS.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-112">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-113">
            <span className="font-bold text-gray-900 text-lg" data-id="element-114">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-green-600" data-id="element-115" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-116" />}
          </button>

          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-117">
            <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-118">
              {faq.answer}
            </div>
          </div>
        </div>)}
    </div>;
}